import Image from 'components/FutureImage';

export default function SafetyWingBanner() {
  return (
    <a
      href="https://safetywing.com/nomad-insurance/?referenceID=travelfeed&campaign=travel-resources&utm_source=travelfeed&utm_medium=Ambassador"
      rel="sponsored noreferrer nofollow"
      target="_blank"
    >
      <div className="tw-relative tw-mt-4">
        <div className="tw-top-0 tw-right-0 tw-absolute tw-text-primary-100 tw-pt-1 tw-pr-2">
          Ad
        </div>
        <Image
          className="tw-rounded tw-w-full tw-h-auto"
          src="https://img.travelfeed.io/travelfeed%2F2024-05-13-14-05-175-ni-banner-hiker-jpg"
          alt="safetywing travel insurance"
          width={1250}
          height={1000}
          sizes="20vw"
        />
      </div>
    </a>
  );
}
